import React from 'react';

import styles from '../styles/footer.module.scss';

import av from '../media/190215-POS-Algemene-Voorwaarden-v1.0.pdf';
import ps from '../media/Privacystatement-OIG_v2019-10-01.pdf';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.footerInnerContainer}>
      <div className={styles.footerRow}>
        <nav className={styles.footerUtilNav}>
          <div>
            <span>&copy; 2019 Nationale Onderwijs Monitors</span>
            <span> &nbsp;&nbsp;|&nbsp;&nbsp; </span>
            <a target='_blank' href={av}>Algemene voorwaarden</a>
            <span> &nbsp;&nbsp;|&nbsp;&nbsp; </span>
            <a target='_blank' href={ps}><nobr>Privacy Statement</nobr></a>
          </div>
          <div className={styles.footerDevelopers}>
            <a target='_blank' href="https://www.hollanddesigns.nl/">
              <nobr>Design Hollanddesigns Grafische vormgeving</nobr>
            </a>
            <span> &nbsp;&nbsp;|&nbsp;&nbsp; </span>
            <a target='_blank' href="https://statuscode.nl/">
              <nobr>Ontwikkeling Status Code</nobr>
            </a>
          </div>
        </nav>
      </div>
    </div>
  </footer>
)

export default Footer
